import React from 'react';
import PropTypes from 'prop-types';
import { legShape } from 'constants/propTypes';
import { isGroupBooking } from 'utils/isGroupBooking';
import { BRUSSEL_UIC } from 'constants/directEurostarStations';
import { ANY_BELGIAN_STATION_NAME } from 'constants/booking';

import ExchangeSummaryOD from '../ExchangeSummaryOD';
import ExchangeSummaryTicket from '../ExchangeSummaryTicket';
import ExchangeSummaryPaxs from '../ExchangeSummaryPaxs';

import { StyledExchangeSummaryWrapper } from '../ExchangeSummary.styles';

const ExchangeSummaryContainer = ({ journey, absProducts, direction = 'outbound', isMiceGroup, ...rest }) => {
  const { timing, origin, destination, classOfService, serviceType, trainNumber, passengers } = rest;
  const isGroup = isGroupBooking(journey?.[0]?.productFamily?.familyGroup);
  const isAbsProducts = absProducts.length > 0;
  const firstLegIsAbs = isAbsProducts && origin.uic === BRUSSEL_UIC;
  const lastLegIsAbs = isAbsProducts && destination.uic === BRUSSEL_UIC;

  return (
    <>
      {firstLegIsAbs && (
        <div data-testid="first-leg-abs">
          <ExchangeSummaryOD
            date={timing.date}
            originName={ANY_BELGIAN_STATION_NAME}
            destinationName={origin.name}
            journeyLength={journey.length}
            classOfService={classOfService}
          />
          <StyledExchangeSummaryWrapper>
            <ExchangeSummaryTicket
              firstLegIsAbs
              timing={timing}
              origin={origin}
              destination={destination}
              trainNumber={trainNumber}
              serviceType={serviceType}
              classOfService={classOfService}
              journey={absProducts}
              direction={direction}
              isMiceGroup={isMiceGroup}
            />
            <ExchangeSummaryPaxs passengers={passengers} isGroup={isGroup} />
          </StyledExchangeSummaryWrapper>
        </div>
      )}
      <div data-testid="summary">
        <ExchangeSummaryOD
          date={timing.date}
          originName={origin.name}
          destinationName={destination.name}
          journeyLength={journey.length}
          classOfService={classOfService}
        />
        <StyledExchangeSummaryWrapper>
          <ExchangeSummaryTicket
            timing={timing}
            origin={origin}
            destination={destination}
            trainNumber={trainNumber}
            serviceType={serviceType}
            classOfService={classOfService}
            journey={journey}
            direction={direction}
            isMiceGroup={isMiceGroup}
          />
          <ExchangeSummaryPaxs passengers={passengers} isGroup={isGroup} />
        </StyledExchangeSummaryWrapper>
      </div>
      {lastLegIsAbs && (
        <div data-testid="last-leg-abs">
          <ExchangeSummaryOD
            date={timing.date}
            originName={destination.name}
            destinationName={ANY_BELGIAN_STATION_NAME}
            journeyLength={journey.length}
            classOfService={classOfService}
          />
          <StyledExchangeSummaryWrapper>
            <ExchangeSummaryTicket
              lastLegIsAbs
              timing={timing}
              origin={origin}
              destination={destination}
              trainNumber={trainNumber}
              serviceType={serviceType}
              classOfService={classOfService}
              journey={absProducts}
              direction={direction}
              isMiceGroup={isMiceGroup}
            />
            <ExchangeSummaryPaxs passengers={passengers} isGroup={isGroup} />
          </StyledExchangeSummaryWrapper>
        </div>
      )}
    </>
  );
};

ExchangeSummaryContainer.propTypes = {
  journey: PropTypes.arrayOf(legShape),
  absProducts: PropTypes.arrayOf(legShape),
  direction: PropTypes.string,
  isMiceGroup: PropTypes.bool
};

export default ExchangeSummaryContainer;
